// Centralized HTTP status & timing constants used across pages.
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_NOT_FOUND = 404;
export const HTTP_TOO_MANY = 429;

export const MS_PER_DAY = 86_400_000;
export const QR_CANVAS_SIZE = 220;
